import {makeStyles} from '@material-ui/core/styles';
export const VPaquetesStyle = makeStyles ((theme) => ({
    center:{
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    flexEnd:{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    contentMargin:{
        margin: "10px 0",
    }
}));